import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "components/MDBox";
import DashboardLayoutCustom2 from "examples/LayoutContainers/DashboardLayoutCustom2";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDTypography from "components/MDTypography";
import Markdown from 'react-markdown'
import { getBusinessSummaryAsync } from "features/actions/auth";

const BITabs = () => {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(null);
  const [businessId, setBusinessId] = useState(localStorage.getItem("common_id"));

  const { sections, loading, error } = useSelector(
    (state) => state.businessSummary
  );

  // Fetch API whenever businessId changes
  useEffect(() => {
    if (businessId) {
      dispatch(getBusinessSummaryAsync(businessId));
    }
  }, [businessId, dispatch]);

  // Sync businessId when localStorage changes (polling method)
  useEffect(() => {
    const interval = setInterval(() => {
      const newBusinessId = localStorage.getItem("common_id");
      if (newBusinessId !== businessId) {
        setBusinessId(newBusinessId);
      }
    }, 1000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [businessId]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  return (
    <MDBox sx={{ backgroundColor: "#f9f9f9" }}>
        <MDBox
          sx={{
            margin: "15px 0px",
            marginTop: "25px",
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            p: 3,
          }}
        >
          <MDTypography
            mt={2}
            mb={4}
            sx={{
              color: "#292929",
              fontFamily: "Urbanist",
              fontSize: "24px",
              fontWeight: 700,
            }}
          >
            Review Summary
          </MDTypography>

          {loading ? (
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
              }}
            >
              <CircularProgress />
            </MDBox>
          ) : error ? (
            <Typography color="error" textAlign="center">
              {error}
            </Typography>
          ) : (
            sections.map((section, index) => (
              <Accordion
                key={index}
                expanded={expanded === index}
                onChange={handleChange(index)}
                sx={{
                  mb: 2,
                  borderRadius: "12px !important",
                  boxShadow:
                    expanded === index
                      ? "0px 4px 8px rgba(0, 0, 0, 0.08)"
                      : "none",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": { backgroundColor: "#f5f5f5" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{
                    backgroundColor: expanded === index ? "#e3f2fd" : "#fff",
                    borderRadius: "12px",
                    transition: "background 0.3s ease-in-out",
                    "&:hover": { backgroundColor: "#e3f2fd" },
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <MDBox
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      fontWeight={600}
                      sx={{ color: "#1565C0", fontSize: "18px" }}
                    >
                      {section.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#666",
                        marginLeft: "auto",
                      }}
                    >
                      {section.date}
                    </Typography>
                  </MDBox>
                </AccordionSummary>

                <AccordionDetails
                  sx={{
                    backgroundColor: "#f9f9f9",
                    borderRadius: "0 0 12px 12px",
                  }}
                >
                  <Typography
                    sx={{ color: "#333", fontSize: "16px", lineHeight: "1.6" , padding: "0 16px" }}
                  >
                  <Markdown>{section.response}</Markdown>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))
          )}
        </MDBox>
    </MDBox>
  );
};

export default BITabs;
